import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Calendar, Chat, UserMultiple } from '@carbon/icons-react';

import styles from './LoginScreen.module.scss';

import LoginForm from 'Screens/Login/LoginForm/LoginForm';
import { Link } from '@carbon/react';

const renderFeatureEmphasis = (chunks: React.ReactNode) => (
    <strong className={styles.featureEmphasis}>{chunks}</strong>
);

const LoginScreen = () => {
    const intl = useIntl();

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <div className={styles.leftContainer}>
                    <header className={styles.header}>
                        <h1 className={styles.headerText}>
                            {intl.formatMessage(messages.headerText)}
                            {' '}
                            <span className={styles.brand}>{intl.formatMessage(messages.brand)}</span>
                        </h1>
                        <p className={styles.headerDescription}>
                            {intl.formatMessage(messages.headerDescription)}
                        </p>
                    </header>
                    <div className={styles.loginContainer}>
                        <LoginForm />
                    </div>
                </div>
                <div className={styles.rightContainer}>
                    <div className={styles.rightOverlay}>

                        <h2 className={styles.rightTitle}>
                            {intl.formatMessage(messages.rightTitle)}
                        </h2>
                        <ul className={styles.features}>
                            <li>
                                <span className={styles.featureIcon}>
                                    <Calendar size={20} />
                                </span>
                                <span>
                                    <FormattedMessage
                                        {...messages.featureOne}
                                        values={{
                                            strong: renderFeatureEmphasis,
                                        }}
                                    />
                                </span>
                            </li>
                            <li>
                                <span className={styles.featureIcon}>
                                    <UserMultiple size={20} />
                                </span>
                                <span>
                                    <FormattedMessage
                                        {...messages.featureTwo}
                                        values={{
                                            strong: renderFeatureEmphasis,
                                        }}
                                    />
                                </span>
                            </li>
                            <li>
                                <span className={styles.featureIcon}>
                                    <Chat size={20} />
                                </span>
                                <span>
                                    <FormattedMessage
                                        {...messages.featureThree}
                                        values={{
                                            strong: renderFeatureEmphasis,
                                        }}
                                    />
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <span>{intl.formatMessage(messages.copyright)}</span>
                <span>•</span>
                <Link href="#">{intl.formatMessage(messages.privacyPolicy)}</Link>
                <span>•</span>
                <Link href="#">{intl.formatMessage(messages.terms)}</Link>
            </div>
        </div>
    );
};

const messages = defineMessages({
    brand: {
        id: 'src.Screens.Login.LoginScreen.brand',
        defaultMessage: 'Appostole',
    },
    headerText: {
        id: 'src.Screens.Login.LoginScreen.headerText',
        defaultMessage: 'Witaj w',
    },
    headerDescription: {
        id: 'src.Screens.Login.LoginScreen.headerDescription',
        defaultMessage: 'Nowoczesne narzędzie do zarządzania parafią i wspólnotą.',
    },
    rightTitle: {
        id: 'src.Screens.Login.LoginScreen.rightTitle',
        defaultMessage: 'Zarządzaj parafią z jednego miejsca',
    },
    featureOne: {
        id: 'src.Screens.Login.LoginScreen.featureOne',
        defaultMessage: '<strong>Twórz</strong> wydarzenia i angażuj wspólnotę',
    },
    featureTwo: {
        id: 'src.Screens.Login.LoginScreen.featureTwo',
        defaultMessage: '<strong>Zarządzaj</strong> grupami parafialnymi',
    },
    featureThree: {
        id: 'src.Screens.Login.LoginScreen.featureThree',
        defaultMessage: 'Czatuj, wysyłaj <strong>ogłoszenia</strong> i <strong>powiadomienia</strong>',
    },
    copyright: {
        id: 'src.Screens.Login.LoginScreen.copyright',
        defaultMessage: '© 2026 Appostoł. Wszelkie prawa zastrzeżone.',
    },
    privacyPolicy: {
        id: 'src.Screens.Login.LoginScreen.privacyPolicy',
        defaultMessage: 'Polityka prywatności',
    },
    terms: {
        id: 'src.Screens.Login.LoginScreen.terms',
        defaultMessage: 'Regulamin',
    },
});

export default LoginScreen;
